<form [formGroup]="formGroup" autocomplete="off" *ngIf="formGroup">
  <maporium-title-description (fieldsChange)="onNameDescriptionChange($event)"
                              [entityId]="element?.id"
                              [fields]="{title: formGroup.get('name')?.value || '', description: formGroup.get('description')?.value || ''}"
                              [isEditing]="true"></maporium-title-description>
  <div class="mt-3">
    <cdk-accordion [multi]="true" class="accordion">
      <maporium-accordion-item [iconClass]="'icon-smap-object-style'"
                               [title]="'MAP_INFO.STYLES.TITLE' | translate">
        <maporium-overlay-element-style-light [element]="element ?? undefined"
                                              [formGroup]="formGroup"></maporium-overlay-element-style-light>
      </maporium-accordion-item>
    </cdk-accordion>
  </div>
</form>
